import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../utils/constants/api';
import { ApiResponse } from '../../../types/APIResponse';
import { apiEndpoints } from '../../../utils/constants/apiEndpoints';
import { DeleteReason, ReasonType } from '../../../types/ReasonTypes';

// Fetch all delete reasons
export const fetchDeleteReasons = createAsyncThunk<
    DeleteReason[],
    void,
    { rejectValue: string }
>('deleteReasons/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const response = await api.get<ApiResponse<DeleteReason[]>>(apiEndpoints.deleteReason.getAll, { params: { type: ReasonType.Lost } });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to fetch delete reasons');
    }
});

// Add new delete reason
export const addDeleteReason = createAsyncThunk<
    DeleteReason,
    DeleteReason,
    { rejectValue: string }
>('deleteReasons/add', async (data, { rejectWithValue }) => {
    try {
        const response = await api.post<ApiResponse<DeleteReason>>(apiEndpoints.deleteReason.create, { data });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to add delete reason');
    }
});

// Update delete reason
export const updateDeleteReason = createAsyncThunk<
    DeleteReason,
    DeleteReason,
    { rejectValue: string }
>('deleteReasons/update', async (data, { rejectWithValue }) => {
    try {
        const response = await api.put<ApiResponse<DeleteReason>>(`${apiEndpoints.deleteReason.update}/${data.id}`, { data: { reason: data.reason, status: data.status, type: ReasonType.Lost, showInPortal: data.showInPortal } });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to update delete reason');
    }
});

// Delete a delete reason
export const deleteDeleteReason = createAsyncThunk<
    { id: string },
    string,
    { rejectValue: string }
>('deleteReasons/delete', async (id, { rejectWithValue }) => {
    try {
        await api.delete(`${apiEndpoints.deleteReason.delete}/${id}`);
        return { id };
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to delete reason');
    }
});
